<template>
    <div>
        <custom-dialog width="400px" v-if="visibleObj.locksetDialog" :visible="visibleObj.locksetDialog"
            @close="dialogVisible('locksetDialog')">
            <div class="lockset-title" slot="header">
              <div> <span class="iconfont icon-chenggong icon-29C01B mr5"></span>{{ dialogObj.price > 0 ? '锁号成功' : '挂号成功'
                }}
                </div>
                <i class="el-icon-close" @click="dialogVisible('locksetDialog')"></i>
              </div>
              <div class="lockset-content" slot="content">
                <div class="content-item">
                    <span class="iconfont icon-haoyuan icon-9AA0A8 mr10"></span>
                    <div class="rigth-line"> 号源：{{ dialogObj.schedulingTime }}</div>
                    <div class="rigth-line"> {{ dialogObj.timeQuantumName }}</div>
                    <div class="rigth-line"> {{ dialogObj.timeName }}{{ dialogObj.registeredCode }}号</div>
                </div>
                <div class="content-item">
                    <span class="iconfont icon-yishengg icon-9AA0A8 mr10"></span>
                    <div class="rigth-line">医生：{{ dialogObj.doctorName }}</div>
                </div>
                <div class="content-item">
                    <span class="iconfont icon-zhenshi icon-9AA0A8 mr10"></span>
                    <div class="rigth-line">诊室：{{ dialogObj.clinicName || '暂无' }}</div>
                </div>
            </div>
            <div class="btns" slot="footer" v-if="dialogObj.price > 0">
                <custom-button size="small" type="info" @click="refundRegister">退号</custom-button>
                <custom-button size="small" type="info" @click="dialogVisible('locksetDialog')">暂不收费</custom-button>
                <custom-button size="small" type="primary" @click="charge">收费 ¥ {{ dialogObj.price }}</custom-button>
            </div>
            <div class="btns" slot="footer" v-else>
                <custom-button size="small" type="info" @click="refundRegister">退号</custom-button>
                <custom-button size="small" type="info" @click="sign">签到</custom-button>
                <custom-button size="small" type="primary" @click="signAndCall">签到并打印</custom-button>
            </div>
        </custom-dialog>

    </div>
</template>
  
<script>
import customDialog from '@/components/customDialog/CustomDialog.vue'
import { debounce } from '@/utils/validateBase'
import { isEmptyArray, isNull } from '@/utils/validateBase'
export default {
    // 定义引入的组件
    components: { customDialog },
    props: {
        visibleObj: {
            type: Object,
            default: {}
        },
        dialogObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {

        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 收费
         */
        charge: debounce(function () {
            this.$emit('updateData')
        }, 1000, true),
        /**
         * 关闭
         */
        dialogVisible(name) {
            this.$emit("closeLokset");
        },
        /**
         * 退号
         */
        refundRegister: debounce(async function () {
            this.$emit('refundRegister')
        }, 1000, true),
        /**
         * 签到并打印
         */
        signAndCall: debounce(function () {
            this.$emit('signAndCall')
        }, 1000, true),
        /**
         * 签到
         */
        sign: debounce(async function () {
            this.$emit('sign')
        }, 1000, true),

    },
}
</script>
<style lang="less" scoped src="./index.less"></style>